<template>
  <v-card
    v-if="node"
    ref="node"
    @click="(event) => handleSpecialClick(event)"
    @contextmenu.stop="showNodeMenu($event)"
    :ripple="false"
    class="pertimm-node"
    max-width="300"
    width="300"
    outlined
    @mouseenter="hoverbtn = true"
    @mouseleave="hoverbtn = false"
  >
    <!-- <v-btn absolute x-small dark fab top right color="blue" style="right: 64px !important" title="Clone node"  @click="cloneNodes()">
      <v-icon>mdi-content-copy</v-icon>
    </v-btn>
    <v-btn absolute x-small dark fab top right color="red" title="Delete node" @click="removeNodes()">
      <v-icon>mdi-close</v-icon>
    </v-btn> -->
    <v-card-title class="justify-center text-justify subtitle-2 py-0">
      <!-- Goal : Delete this chekbox and turn it to action -->
      <!-- <v-checkbox
        @change="
          updateNode({
            skillId: $route.params.skillId,
            idNode: node._id, 
            data: node
          })
        "
        v-model="node.waitUserInput"
      ></v-checkbox> -->
      <v-text-field
        v-model="node.name"
        color="black"
        v-if="nameEditMode"
        @blur="enableNameEditMode(false)"
        @keyup.enter="enableNameEditMode(false)"
        class="node-name-input pa-0 ma-0"
      ></v-text-field>
      <p
        style="cursor: pointer"
        v-else
        @dblclick="enableNameEditMode(true)"
        class="node-name-label d-flex text-truncate justify-center align-center py-0 my-0"
      >
        {{ node.name || "..." }}
      </p>
    </v-card-title>

    <v-divider v-if="!nameEditMode" class="mx-4"></v-divider>

    <v-container class="py-0">
      <!-- Added actions -->
      <v-row>
        <v-col class="pb-0 actions-bloc">
          <div class="d-flex flex-column">
            <!-- Actions List -->
            <div
              class="d-flex align-center wrap-action"
              :class="`wrap-action-${action.actionType}`"
              @contextmenu="show()"
              v-for="(action, i) in node.actions"
              :key="i"
            >
              <span
                style="cursor: pointer; width: 100%;"
                class="caption"
                @dblclick="handleDoubleClickOnAction(i, action)"
              >
                <span
                  v-if="action.actionType === 'message'"
                  @contextmenu.stop="showActionMenu($event, action)"
                  class="d-flex flex-column text-left mt-1"
                  style="width: 100%; background-color: #F2F2F2; border-radius: 10px; font-size: 10px; margin-bottom: 5px;  padding: 2px;"
                >
                  <span
                    class="ml-1 font-weight-regular black--text"
                    style="line-height: normal; letter-spacing: normal; font-size: 14px;"
                  >
                    {{
                      action.actionType === "message"
                        ? getFirstMessage(action)
                        : action.name
                    }}
                  </span>
                  <span
                    v-if="nodeMessages.length > 1"
                    style="font-style: italic; font-size: 7px;"
                  >
                    paraphrases
                  </span>
                </span>
                <span
                  v-else-if="action.actionType === 'vikyAction'"
                  @contextmenu.stop="showActionMenu($event, action)"
                  class="font-weight-regular black--text text-center"
                  style="display: block; padding: 2px; width: 100%; border-radius: 10px; font-size: 10px;"
                  :style="action.name.includes('long') ? 'background-color: #FFE7E7;':'background-color: #FFF7C8;'"
                >
                  {{ action.name.includes('long') ? action.name : "Waiting for a short response"  }}
                </span>
                <span
                  v-else-if="action.actionType === 'nextSkill'"
                  @contextmenu.stop="showActionMenu($event, action)"
                  class="text-left mt-1"
                  style="display: block; padding: 2px; width: 100%; background-color: #63AB52; border-radius: 10px; font-size: 10px;"
                >
                  <v-icon>mdi-arrow-right-bold</v-icon>
                  <span class="ml-1 font-weight-regular black--text">
                    {{ getSkillName(action.args[0]) }}
                  </span>
                </span>
                <span
                  v-else
                  class="text-left mt-1 mb-1"
                  @contextmenu.stop="showActionMenu($event, action)"
                  style="display: block; width: 100%; background-color: #CEBCFF; border-radius: 10px; font-size: 10px; padding: 2px;"
                >
                  <span class="ml-1 font-weight-regular black--text">
                    {{ action.name }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Actions menu -->
      <v-row>
        <v-col class="pt-2">
          <div class="d-flex flex-column align-center">
            <template>
              <div v-if="node.actions.length < 1">
                <v-btn tex icon small color="primary" @click="dialog = true">
                  <v-icon>mdi-playlist-plus</v-icon>
                </v-btn>
              </div>
            </template>
            <v-dialog v-model="dialog" width="500">
              <v-card>
                <div class="d-flex flex-column align-center">
                  <div class="pt-4">
                    <v-btn
                      text
                      @click="handleSendMessages();"
                      >Send message</v-btn
                    >
                  </div>
                  <div id="viky" class="pt-4">
                    <v-btn
                      text
                      @click="
                        action.actionType = 'vikyAction';
                        action.args[0] = '';
                        action.name = 'Waiting for a short response ';
                        addActions();
                      "
                      >Wait for short response</v-btn
                    >
                  </div>
                  <div id="viky" class="pt-4">
                    <v-btn
                      text
                      @click="
                        action.actionType = 'vikyAction';
                        action.args[0] = '';
                        action.name = 'Waiting for a long response ';
                        addActions();
                      "
                      >Wait for long response</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                      text
                      @click="
                        dialogAction = true;
                        action.actionType = 'clearSlots';
                        action.args[0] = '';
                        action.name = '';
                      "
                      >Clear Slots</v-btn
                    >
                  </div>
                  <!-- NextSkill Action : disabled -->
                  <div class="pt-4">
                    <v-btn
                      text
                      @click="
                        dialogAction = true;
                        action.actionType = 'nextSkill';
                        action.args[0] = '';
                        action.name = '';
                      "
                      >Next Story</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                      text
                      @click="
                        dialogAction = true;
                        action.actionType = 'customAction';
                        action.args[0] = '';
                        action.name = '';
                      "
                      >Custom Action</v-btn
                    >
                  </div>
                  <div class="pt-4">
                    <v-btn
                      text
                      @click="
                        dialogAction = true;
                        action.actionType = 'delay';
                        action.args[0] = '';
                        action.name = '';
                      "
                      >Delay</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-divider v-if="!nameEditMode" class="mx -4"></v-divider>

    <v-container class="py-0 mt-3">
      <v-row>
        <v-col class="pt-0 flex-grow-0">
          <div class="d-flex flex-column">
            <Anchor
              ref="anchorIn"
              v-for="anchor in anchors.in"
              :key="anchor._id"
              :id="anchor._id"
              :name="anchor.name"
              :value="anchor.value"
              :variable="anchor.variable"
              @onDeleted="onDeletedAnchor"
              @onChanged="onAnchorChanged"
              @onUpdateAnchors="updateAnchorsList($event)"
              @onConnectionAnchor="connectionAnchor($event)"
            />
          </div>
        </v-col>
        <v-col class="pt-0">
          <div class="d-flex flex-column align-end">
            <Anchor
              ref="anchorOut"
              v-for="anchor in sortedOutAnchors"
              :key="anchor._id"
              :id="anchor._id"
              :name="anchor.name"
              :value="anchor.value"
              :variable="anchor.variable"
              :allAnchors="anchors"
              :currentNodeId="id"
              :currentSkillId="$route.params.skillId"
              :isEnd="node.end"
              :available="anchor.available"
              :openedMenuAnchor="openedMenuAnchor"
              @menuOpened="openedMenuAnchor = $event"
              @onDeleted="onDeletedAnchor"
              @onChanged="onAnchorChanged"
              @onUpdateAnchors="updateAnchorsList($event)"
              @onConnectionAnchor="connectionAnchor($event)"
              @onMarkEndNode="markEndNode($event)"
              @onMarkNonAvailableNode="MarkNonAvailableNode($event)"
              @onHoverAnchor="handleHoverAnchor($event)"
              out
            />
          </div>
        </v-col>
      </v-row>
      <v-row style="position: absolute; bottom: 2px; right: 117px;">
        <v-col class="pa-0">
          <div class="d-flex flex-column align-end">
            <NewAnchor out @created="createAnchorOnEvent" />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Save the present node -->
    <!-- <slot v-if="!node.isSaved">
      <v-btn icon x-small color="blue lighten-2" title="Set as favourite">
        <span  @click="setFavourite">
          <v-icon>mdi-bookmark-outline</v-icon>
        </span>
      </v-btn>
    </slot>
    <slot v-if="node.isSaved">
      <v-btn icon x-small color="blue lighten-2" title="Unset from favourite">
        <span  @click="unsetFavourite">
          <v-icon>mdi-bookmark</v-icon>
        </span>
      </v-btn>
    </slot> -->

    <!-- labo-->
    <!-- <slot v-if="hover">
      <v-btn icon small color="green">
        <span  @click="show">
          <v-icon>mdi-access-point</v-icon>
        </span>
      </v-btn>
    </slot> -->
    <!-- End of my labo -->

    <v-dialog v-model="dialogAction" width="800" persistent>
      <v-card>
        <div v-if="action.actionType === 'message'">
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="action.name"></v-text-field> -->
          <v-textarea
            class="px-4"
            placeholder="Message"
            v-model="action.args[0]"
          ></v-textarea>
        </div>

        <div v-if="action.actionType === 'clearSlots'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="action.name"
          ></v-text-field>
        </div>

        <div v-if="action.actionType === 'nextSkill'">
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="action.name"></v-text-field> -->
          <v-select
            class="px-4"
            :items="skills"
            item-text="name"
            item-value="_id"
            v-model="action.args[0]"
            label="Next Story"
          ></v-select>
        </div>
        <div v-if="action.actionType === 'customAction'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="action.name"
          ></v-text-field>
          <PrismEditor
            class="my-editor"
            v-model="action.args[0]"
            :highlight="highlighter"
            line-numbers
            language="javascript"
          ></PrismEditor>
        </div>
        <div v-if="action.actionType === 'delay'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="action.name"
          ></v-text-field>
          <v-text-field
            class="px-4"
            v-model="action.args[0]"
            type="number"
            placeholder="Seconds"
          ></v-text-field>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white-text" @click="dialogAction = false">
            cancel
          </v-btn>
          <v-btn
            v-if="action.actionType !== 'message'"
            color="secondary"
            @click="addActions()"
            >add</v-btn
          >
          <v-btn
            v-else
            :disabled="action.args[0] === ''"
            color="secondary"
            @click="addActions()"
            >add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogEditAction"
      width="800"
      v-if="node.actions[actionIndex]"
      persistent
    >
      <v-card>
        <div
          class="pt-4 px-4"
          v-if="node.actions[actionIndex].actionType === 'message'"
          @click="handleOutsideClick()"
        >
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="node.actions[actionIndex].name"></v-text-field> -->
          <!-- <v-textarea
            v-if="editingMessage"
            id="textAreaMessage"
            class="px-4"
            placeholder="Message"
            v-model="node.actions[actionIndex].args[0]"
          ></v-textarea> -->
          <div style="display: flex; flex-wrap: wrap; justify-content: space-evenly;">
            <div style="display: flex; flex-wrap: nowrap; width:100%; justify-content: space-between;">
              <v-btn color="#F8E35A" @click.stop="handleEmotion('ENTHOUSIASTE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Enthousiaste</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('EVIDENCE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Evidence</v-btn>
              <v-btn color="#F8E35A" @click="handleEmotion('ESPIEGLE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Espiegle</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('RECONFORTANT')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Réconfortant</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('PENSIF')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Pensif</v-btn>
              <v-btn color="#FB9F9F" @click.stop="handleEmotion('COLERE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Colère</v-btn>
            </div>
            <div style="display: flex; flex.stop-wrap: nowrap; width:100%; justify-content: space-between; margin-top: 10px; margin-bottom: 10px;">
              <v-btn color="#E1E1E1" @click.stop="handleEmotion('NARRATION')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Narration</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('INCREDULE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Incredule</v-btn>
              <v-btn color="#F8E35A" @click.stop="handleEmotion('ETONNE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Etonné</v-btn>
              <v-btn color="#B3D5F7" @click.stop="handleEmotion('DESOLE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Désolé</v-btn>
              <v-btn color="#CEBCFF" @click.stop="handleEmotion('SUPPLIANT')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Suppliant</v-btn>
              <v-btn color="#FF9E3D" @click.stop="handleEmotion('DETERMINE')" style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;">Determiné</v-btn>
            </div>
            <!-- <v-btn
              v-for="(emotion, index) in emotions"
              :key="index"
              :color="emotion.color"
              @click="handleEmotion(emotion.name)"
              style="width: 85px; height: 25px; font-size: xx-small; font-weight: bolder; text-transform: capitalize; margin: 10px 10px;"
            >
              {{ emotion.label }}
            </v-btn> -->
          </div>
          <div
            class="paragraph"
            v-for="(paragraph, index) in nodeMessages"
            :key="index"
          >
            <v-btn
              variant="outlined"
              icon
              color="red"
              @click="listenToParagraph(paragraph)"
            >
              <v-icon>mdi-headphones</v-icon>
            </v-btn>
            <v-textarea
              ref="textarea"
              auto-grow
              class="mt-1 custom-textarea"
              rows="3"
              row-height="25"
              outlined
              rounded
              @focus="handleFocusMessageBlock(index)"
              @click.stop="getCursuroPosition($event, index)"
              v-model="nodeMessages[index]"
            ></v-textarea>
            <div style="display: flex; flex-direction: column;">
              <!-- <v-badge color="green" class="ml-2 mr-4">
                <template v-slot:badge>
                  <span class="mdi mdi-comment"></span>
                </template>
              </v-badge> -->
              <v-btn
                variant="outlined"
                icon
                color="red"
                @click="clearMessageBlock(index)"
                class="ml-2 mr-2"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn
                variant="outlined"
                icon
                color="red"
                @click=""
                class="ml-2 mr-2"
              >
                <v-icon color="green">mdi-comment</v-icon>
              </v-btn>
            </div>
            <!-- <span style="line-height: 20px;" v-html="paragraph"> </span> -->
          </div>
          <div style="width: 20%;
                          background-color: #E7E7E7;
                          border-radius: 25px;
                          display: flex;
                          flex-direction: row;
                          flex-wrap: nowrap;
                          align-items: center;
                          margin: 0 auto;
                          cursor: pointer;"
              @click="addParaphrase(actionIndex)"
          >
            <span class="mdi mdi-plus-circle" style="font-size: larger;"></span>
            <span style="font-size: x-small; margin-left: 5px;">Ajouter une paraphrase</span>
          </div>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'clearSlots'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <v-combobox
            v-model="node.actions[actionIndex].args[0]"
            :items="node.actions[actionIndex].args[0]"
            class="px-4"
            label="Slots"
            multiple
            small-chips
          ></v-combobox>
        </div>
        <div
          v-if="node.actions[actionIndex].actionType === 'nextSkill'"
          style="padding-top: 5px;"
        >
          <!-- <v-text-field class="px-4" placeholder="Name" v-model="node.actions[actionIndex].name"></v-text-field> -->
          <v-select
            class="px-4"
            :items="skills"
            item-text="name"
            item-value="_id"
            v-model="node.actions[actionIndex].args[0]"
            label="Next Story"
          ></v-select>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'customAction'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <PrismEditor
            class="my-editor"
            v-model="node.actions[actionIndex].args[0]"
            :highlight="highlighter"
            line-numbers
            language="javascript"
          ></PrismEditor>
        </div>
        <div v-if="node.actions[actionIndex].actionType === 'delay'">
          <v-text-field
            class="px-4"
            placeholder="Name"
            v-model="node.actions[actionIndex].name"
          ></v-text-field>
          <v-text-field
            class="px-4"
            v-model="node.actions[actionIndex].args[0]"
            type="number"
            placeholder="Seconds"
          ></v-text-field>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            v-if="action.actionType === 'message' && this.editingMessage"
            color="#F8F8F8"
            plain
            class="black-text"
            style="font-weight: 900;"
            @click="closeDialog()"
          >
            cancel
          </v-btn>
          <v-btn
            color="secondary"
            class="white-text"
            style="font-weight: 900;"
            :disabled="node.actions[actionIndex].args[0].length === 0"
            @click="updateActions(node.actions[actionIndex])"
          >
            save
          </v-btn>
          <!-- Pour actionType === 'message' -->
          <!-- <v-btn
            v-if="
              node.actions[actionIndex].actionType === 'message' &&
                this.editingMessage
            "
            color="primary"
            class="white-text"
            @click="editingMessage = false"
          >
            listen
          </v-btn> -->

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      close-on-content-click
      :min-width="200"
    >
      <template v-slot:activator="{ on }">
        <div class="jsPlumb-canvas-container22" @contextmenu="show">
          <slot v-on="on"></slot>
        </div>
      </template>
      <v-list dense>
        <v-list-item v-for="(item, index) in items" :key="index" :disabled="shouldShowItem(item)" :style="{ opacity: shouldShowItem(item) ? 0.5 : 1 }">
          <div>
            <v-list-item @click="callAction(item.action)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
        <v-list-item
          v-if="shouldDisplayConnectionAction && showConnectionAction"
        >
          <div>
            <v-list-item @click="callAction('connectNode')">
              <v-list-item-icon>
                <v-icon v-text="'mdi-link-variant'"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>Connection</v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
        <v-list-item>
          <div>
            <v-list-item @click="handleBookmark()">
              <v-list-item-icon>
                <v-icon
                  v-text="
                    node.isSaved ? 'mdi-bookmark-remove' : 'mdi-bookmark-check'
                  "
                ></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                node.isSaved ? "Supprimer des favoris" : "Ajouter aux favoris"
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-chat</v-icon>
              </v-list-item-icon>
              <v-list-item-title
                @click="startChat"
                style="text-decoration: none; color: inherit; cursor: pointer;"
              >
                Start chat from node
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      v-model="actionMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      close-on-content-click
      :min-width="200"
      class="v-menu-canvas-link"
    >
      <v-list-item style="background-color: white" @click="dialog = true">
        <v-list-item-icon>
          <v-icon>mdi-plus-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>New Action</v-list-item-title>
      </v-list-item>
      <v-list-item
        style="background-color: white"
        @click="removeActions(actionContextMenu._id, actionContextMenu.name)"
      >
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Delete Action</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="actionIndex != 0"
        style="background-color: white"
        @click="moveActions(node.actions, actionIndex, actionIndex - 1)"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-up-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move up</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="actionIndex != node.actions.length - 1"
        style="background-color: white"
        @click="moveActions(node.actions, actionIndex, actionIndex + 1)"
      >
        <v-list-item-icon>
          <v-icon>mdi-arrow-down-thick</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Move down</v-list-item-title>
      </v-list-item>
    </v-menu>

    <!-- Commentaire (Show - Edit - Save)-->
    <div
      v-if="node.comment || editingComment"
      class="text-left mt-1"
      @mouseover="handleExpandComment"
      @mouseout="handleExpandComment"
      @dblclick="EnableEditingComment"
      style="position: absolute; width: 100%; border-radius: 25px;"
    >
      <div
        v-if="!editingComment"
        class="h-100 w-100 d-flex align-start pa-1 text-wrap"
        style="background-color: lemonchiffon; 
            border: thin solid rgba(0, 0, 0, 0.12);
            border-radius: 25px;"
        @contextmenu.stop.prevent="openCommentMenu($event)"
      >
        <span
          class="flex-grow-1 d-block pa-2"
          :class="!expandComment ? 'text-truncate' : ''"
          style="width: 265px; word-wrap: break-word;"
        >
          {{ node.comment }}
        </span>

        <v-icon class="mt-2">{{
          !expandComment ? "mdi-chevron-down" : "mdi-chevron-up"
        }}</v-icon>
      </div>

      <div
        v-else
        class="d-flex flex-wrap align-start pa-1 mt-1"
        style="border: thin solid rgba(0, 0, 0, 0.12);
                  border-radius: 25px;
                  background-color: white;"
      >
        <v-textarea
          hide-details
          no-resize
          v-model="node.comment"
          placeholder="Ajouter votre commentaire ici...!"
          @keydown.enter.prevent="addComment"
          class="flex-grow-1 pa-1 mr-4 commentTextarea"
        >
        </v-textarea>

        <v-icon
          class="pa-1 align-start"
          style="position: absolute; right: 4px;"
          @click="handleCommentToggle"
        >
          {{
            expandComment && EnableEditingComment
              ? "mdi-chevron-down"
              : "mdi-chevron-up"
          }}
        </v-icon>

        <div class="flex-grow-1 d-flex justify-end">
          <v-btn
            color="success"
            class="mt-2 mb-1 ml-2 mr-1"
            @click="addComment"
          >
            Save
          </v-btn>
        </div>
      </div>

      <v-menu
        v-model="showCommentMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        close-on-content-click
        :min-width="200"
      >
        <template v-slot:activator="{ on }">
          <slot v-on="on"></slot>
        </template>
        <span
          class="d-flex h-bg-white pa-1"
          style="background-color: white; height: 30px; cursor: pointer;"
          @click="deleteComment"
          >Supprimer commentaire</span
        >
      </v-menu>
    </div>

  </v-card>
</template>

<script>
import { mapActions } from "vuex";

import Anchor from "./Anchor";
import NewAnchor from "./NewAnchor";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    excludedNode: {
      type: String,
      required: false,
    },
    showConnectionAction: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Anchor,
    NewAnchor,
    PrismEditor,
  },
  data() {
    return {
      waitUserInput: true,
      inputNameValue: "",
      dialog: false,
      dialogAction: false,
      dialogGlobalAction: false,
      dialogEditAction: false,
      actionIndex: 0,
      action: { name: "", args: [], actionType: "message" },
      nameEditMode: false,
      node: null,
      nodeMessages:[],
      blockMessageFocusedIndex: null,
      isTextareaFocused: false,
      MessageCursorPosition: null,
      messageBlockEvent: null,
      emotions: [
        { name: "ENTHOUSIASTE", label: "Enthousiaste", color: "#F8E35A" },
        { name: "EVIDENCE", label: "Evidence", color: "#F8E35A" },
        { name: "ESPIEGLE", label: "Espiegle", color: "#F8E35A" },
        { name: "RECONFORTANT", label: "Réconfortant", color: "#B3D5F7" },
        { name: "PENSIF", label: "Pensif", color: "#B3D5F7" },
        { name: "COLERE", label: "Colère", color: "#FB9F9F" },
        { name: "NARRATION", label: "Narration", color: "#E1E1E1" },
        { name: "INCREDULE", label: "Incredule", color: "#F8E35A" },
        { name: "ETONNE", label: "Etonné", color: "#F8E35A" },
        { name: "DESOLE", label: "Désolé", color: "#B3D5F7" },
        { name: "SUPPLIANT", label: "Suppliant", color: "#CEBCFF" },
        { name: "DETERMINE", label: "Determiné", color: "#FF9E3D" }
      ],
      isLoading: false,
      search: null,
      actions: [],
      filterAction: { q: null, sort: "recentAsc", page: 1 },
      sortingOptions: [
        { name: "Oldest", value: "recentDesc" },
        { name: "Recent", value: "recentAsc" },
      ],
      loding: false,
      noMoreAction: false,
      skills: [],
      nodeId: "",
      hoverbtn: false,
      items: [
        {
          title: "Dupliquer",
          icon: "mdi-content-copy",
          action: "cloneNode",
        },
        {
          title: "Supprimer",
          icon: "mdi-delete",
          action: "deleteNode",
        },
        {
          title: "Commentaire",
          icon: "mdi-comment",
          action: "commentNode",
        },
        {
          title: "Copier une selection",
          icon: "mdi-selection-multiple",
          action: "duplicateSelection",
        },
      ],
      showMenu: false,
      x: 0,
      y: 0,
      // alert: false,
      nodeStartConection: null,
      nodeEndConection: null,
      editingMessage: false,
      expandComment: false,
      editingComment: false,
      showCommentMenu: false,
      actionMenu: false,
      actionIndex: null,
      actionContextMenu: null,
      showAddActionButton: true,
      //Add user
      userId: 1258089477,
      name: "User",
      patientId: "",
      demoPatientId: 999,
      //
      openedMenuAnchor: null,
    };
  },

  methods: {
    ...mapActions({
      createAnchor: "http/anchors/createAnchor",
      updateAnchor: "http/anchors/updateAnchor",
      removeAnchor: "http/anchors/removeAnchor",
      updateNode: "http/nodes/updateNode",
      getNode: "http/nodes/getNode",
      cloneNode: "http/nodes/cloneNode",
      removeNode: "http/nodes/removeNode",
      getActions: "http/nodes/getActions",
      addAction: "http/nodes/addAction",
      updateAction: "http/nodes/updateAction",
      removeAction: "http/nodes/removeAction",
      loadAnchorTypes: "http/anchors/loadAnchorTypes",
      addSavedNodeToTemplate: "canvas/addSavedNode",
      removeSavedNodeFromTemplate: "canvas/removeSavedNode",
    }),
    focusPrism(event) {
      const prismTextarea = event.target.querySelector(
        ":scope > .prism-editor__container textarea"
      );
      if (prismTextarea) {
        prismTextarea.focus();
      }
    },
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    },

    getSkills() {
      return this.$http
        .get(`/projects/${this.$route.params.id}/skills/`)
        .then(({ data }) => {
          this.skills = data.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
        });
    },
    async filter() {
      this.filterAction.page = 1;
      this.actions = await this.getActions({ filter: this.filterAction });
    },
    async showMore() {
      this.loding = true;
      this.filterAction.page += 1;
      const newActions = await this.getActions({ filter: this.filterAction });
      this.actions.push(...newActions);
      this.loding = false;
      if (newActions.length === 0) this.noMoreAction = true;
    },
    // async getIntents() {
    //   const data = await this.$store.dispatch("http/intents/get", {
    //     this.$route.params.id: this.$route.params.id,
    //   });
    //   this.intents = data;
    // },
    handleSendMessages() {
      if (
        this.node.actions.map((x) => x.actionType).includes("message") &&
        this.action.actionType === "message"
      ) {
        this.$toasted
          .error("Message Action already exists for this node!")
          .goAway(3000);
      } else {
        this.dialogAction = true;
        this.action.actionType = 'message';
        this.action.args[0] = '';
        this.action.name = '';
      }
    },
    async addActions() {
      if (
        this.node.actions.map((x) => x.actionType).includes("vikyAction") &&
        this.action.actionType == "vikyAction"
      ) {
        this.$toasted
          .error("Waiting Action already exists for this node!")
          .goAway(3000);
      } else if (
        this.node.actions.map((x) => x.actionType).includes("message") &&
        this.action.actionType === "message"
      ) {
        this.$toasted
          .error("Message Action already exists for this node!")
          .goAway(3000);
      } else {
        await this.addAction({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          action: { action: this.action },
        });
        const node = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        this.node.actions = node.actions;
        this.action.name = "";
        this.action.args[0] = [];
        this.dialog = false;
        this.dialogAction = false;
        this.dialogGlobalAction = false;
        this.showAddActionButton = false;
      }
    },
    async removeActions(actionId, actionName) {
      this.$confirm(
        `Are you sure you want to delete the Action <strong>${actionName}</strong> ?`
      ).then(async (res) => {
        if (res) {
          if (this.node.actions === 0 && !this.showAddActionButton) {
            this.showAddActionButton = true;
          }
          await this.removeAction({
            skillId: this.$route.params.skillId,
            idNode: this.id,
            actionId,
          });
          const node = await this.getNode({
            skillId: this.$route.params.skillId,
            idNode: this.id,
          });
          this.node.actions = node.actions;
        }
      });
    },
    // Moving actions up and down && updating
    async moveActions(actionsList, from, to) {
      actionsList.splice(to, 0, actionsList.splice(from, 1)[0]);
      const currentNode = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      const nodeActionsList = currentNode.actions;
      nodeActionsList.splice(to, 0, nodeActionsList.splice(from, 1)[0]);
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { actions: nodeActionsList },
      });
    },
    // Event updating anchors list
    updateAnchorsList(value) {
      // If the present node is the default one -> "acnhors.in" list is empty. If not, I cut the list received from parent.
      //console.log("Received value from anchors :", value);
      if (this.anchors.in.length == 0) {
        this.node.anchors = value.out;
      } else {
        var head = this.node.anchors.slice(0, 2);
        var finalList = head.concat(value.out.slice(1));
        this.node.anchors = finalList;
      }
    },
    // Send to parent
    sendNodeElement() {
      this.$emit("onUpdateSelection", this.$el.id);
    },
    handleSpecialClick(event) {
      if (event.ctrlKey || event.metaKey) {
        this.sendNodeElement();
      }
    },
    //transform plain text into html paragraphs.
    transoformToPragraphs(action) {
      let lines = action.args[0].split(/\r\n|\r|\n/);
      let paragraphs = [];
      for (let line in lines) {
        if (lines[line].slice(-1).includes(":" || "?")) {
          paragraphs.push(
            '<p class="ml-2 mr-2">' + lines[line] + "</p>\n" + "<br >"
          );
          continue;
        } else {
          paragraphs.push(
            '<p class="ml-2 mr-2 mt-1">' +
              lines[line].replace(/\n/g, "</p>\n<p>") +
              "</p>\n"
          );
          continue;
        }
      }
      return paragraphs;
    },
    getMessage(action) {
      return action.args[0].split(/\r\n|\r|\n/);
    },
    addParaphrase() {
      this.nodeMessages.push("");
      this.$nextTick(() => {
        const lastIndex = this.nodeMessages.length - 1;
        this.$refs.textarea[lastIndex].focus();
        this.blockMessageFocusedIndex = lastIndex;
        this.MessageCursorPosition = 0;
      });
    },
    async closeDialog() {
      this.editingMessage = false;
      this.dialogEditAction = false;
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      this.node.actions = node.actions;
      this.nodeMessages = [];
      node.actions.filter((action) => {
        if(action.actionType === "message") {
          this.nodeMessages = action.args;
        }
      })
    },
    async updateActions(action) {
      if (action.actionType === 'message') {
        action.args = action.args.filter(arg => arg.length !== 0);
        this.nodeMessages = this.nodeMessages.filter(message => message.length !== 0);
        // this.nodeMessages = action.args
              await this.updateAction({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        action,
        actionId: action._id,
      });
      } else {
        
      }
      action.args = this.nodeMessages;
      await this.updateAction({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        action,
        actionId: action._id,
      });
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      this.node.actions = node.actions;
      // closing the dialog if we're not editing the message.
      if (!this.editingMessage) this.dialogEditAction = false;
      else this.dialogEditAction = true;
      this.editingMessage = false;
      this.dialogEditAction = false;
    },
    removeTagsFromtext(str) {
      var start = str.indexOf(">");
      var end = str.indexOf("<", start + 1);
      var result = str.substring(start + 1, end);
      return result.replace(/\n/g, "");
    },
    transformerTexte(texte) {
      const regexVariables = /\${[^}]+}/g;

      // Utilisez la méthode replace() avec une fonction de remplacement pour les variables
      const texteSansVariables = texte.replace(regexVariables, (match) => {
        // Supprimez les caractères `${` et `}` et obtenez le nom de la variable
        const variable = match.slice(2, -1);
        
        // Divisez la variable en utilisant des points et renvoyez la dernière partie (nom de la variable)
        const parties = variable.split('.');
        return parties[parties.length - 1];
      });

      // Utilisez une expression régulière pour supprimer les caractères spéciaux ♀ et ♂
      const regexCaracteresSpeciaux = /♀[^♂]*[♂\W]*/g;
      const texteSansCaracteresSpeciaux = texteSansVariables.replace(regexCaracteresSpeciaux, '');
      const texteTransforme = texteSansCaracteresSpeciaux.replace(/\s+/g, ' ');

      return texteTransforme;
    },
    handleOutsideClick() {
      this.isTextareaFocused = false;
      this.blockMessageFocusedIndex= null;
      this.MessageCursorPosition = null;
    },
    handleEmotion(emotion) {
      const { blockMessageFocusedIndex, MessageCursorPosition, nodeMessages, isTextareaFocused } = this;

      if (isTextareaFocused && blockMessageFocusedIndex !== null) {
        const messageElement = this.$refs.textarea[blockMessageFocusedIndex];
        
        const textBefore = nodeMessages[blockMessageFocusedIndex].substring(0, MessageCursorPosition);
        const textAfter = nodeMessages[blockMessageFocusedIndex].substring(MessageCursorPosition);

        const emotionText = '<' + emotion + '>';
        const finalText = textBefore + emotionText + textAfter;

        this.$set(this.nodeMessages, blockMessageFocusedIndex, finalText);

        const newPosition = textBefore.length + emotionText.length;
        this.MessageCursorPosition = newPosition;
        console.log('nodeMessages : ', nodeMessages[blockMessageFocusedIndex]);

        this.setCaretPosition(messageElement.$refs.input, newPosition);
      }
    },
    setCaretPosition(elem, caretPos) {
      if (elem !== null) {
        elem.focus();
        elem.selectionStart = caretPos;
        elem.selectionEnd = caretPos;

            setTimeout(() => {
              // Set the cursor at the end of the text after the value has been updated
              elem.selectionStart = caretPos;
              elem.selectionEnd = caretPos;
            }, 200);
      }
    },
    clearMessageBlock(blockIndex) {
      if(this.nodeMessages.length > 1) {
        this.nodeMessages.splice(blockIndex, 1);
      } else {
        this.nodeMessages = [];
      }
    },
    handleFocusMessageBlock(blockIndex) {
      this.blockMessageFocusedIndex = blockIndex;
      this.isTextareaFocused = true;
    },
    getCursuroPosition(event, index) {
      this.MessageCursorPosition = event.target.selectionStart;
      this.$refs.textarea[index].focus();
      this.blockMessageFocusedIndex = index;
      this.messageBlockEvent = event.target;
    },
    listenToParagraph(paragraph) {
      const texteTransforme = this.transformerTexte(paragraph);
      let audioContext;
      if (window.AudioContext) {
        audioContext = new AudioContext();
      } else {
        // eslint-disable-next-line no-undef, new-cap
        audioContext = new webkitAudioContext();
      }
      this.$http
        .post(
          "/generate-audio",
          { speaker_id: "0", text: paragraph },
          {
            responseType: "arraybuffer",
          }
        )
        .then((data) => {
          this.playAudio(data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async playAudio(audioData) {
      var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      let source = audioCtx.createBufferSource();
      audioCtx.decodeAudioData(audioData, function(buffer) {
        source.buffer = buffer;
        source.connect(audioCtx.destination);
        source.start(0);
      });
    },
    async setFavourite() {
      // Make the difference between saving the default node or a normal node
      if (
        (this.node.actions.length == 0 &&
          this.node.anchors.map((x) => x.name).includes("in") &&
          this.node.anchors.length <= 2) ||
        (this.node.actions.length == 0 &&
          !this.node.anchors.map((x) => x.name).includes("in") &&
          this.node.anchors.length <= 1)
      ) {
        this.$fire({
          title: "Oops.. Empty node",
          text: "You can't save an empty node!",
          type: "error",
          timer: 3000,
        });
      } else {
        this.savingModel = true;
        this.node.isSaved = true;
        await this.updateNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          data: { isSaved: true, name: this.node.name },
        });
        this.$toasted.show("Node saved successfully", {
          theme: "toasted-primary",
          position: "top-center",
          duration: 2000,
        });
        // Add the selected node to template
        await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        }).then((data) => {
          this.addSavedNodeToTemplate(data);
        });
      }

      let nodeRef = this.$refs;
      nodeRef.node.$el.style.backgroundColor = "lightsteelblue";
    },
    async unsetFavourite() {
      this.node.isSaved = false;
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { isSaved: false, name: this.node.name },
      });
      // remove the selected node from template
      await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      }).then((data) => {
        this.removeSavedNodeFromTemplate(data);
      });

      let nodeRef = this.$refs;
      nodeRef.node.$el.style.backgroundColor = "white";
    },
    async isFavourite() {
      const node = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      if ((node.isSaved = true)) return true;
      else return false;
    },
    getFirstMessage(action) {
      if (action.actionType !== "message") return action.args[0];

      // Generate a random index within the array's length
      const randomIndex = Math.floor(Math.random() * action.args.length);

      return action.args[randomIndex];
    },
    async show() {
      const myNode = await this.getNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
      });
      console.log("myNode.isSaved :", myNode);
      console.log("this.node : ", this.node);
    },
    showNodeMenu(e) {
      this.$emit("hideContextMenu", "nodeClicked");
      // this.showMenu = true;
      e.preventDefault();
      if (this.showMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    showActionMenu(e, action) {
      e.preventDefault();

      this.actionIndex = this.node.actions.indexOf(action);
      this.actionContextMenu = action;
      if (this.actionMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.actionMenu = false;
      this.$nextTick(() => {
        this.actionMenu = true;
      });
    },
    cloneNodes() {
      this.cloneNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: {
          position: {
            x: this.node.position.x + 50,
            y: this.node.position.y + 50
          }
        }
      }).then((data) => {
        data.position.x = data.position.x + 50;
        data.position.y = data.position.y + 50;
        this.$emit("onUpdateClone", data);
      });
    },
    removeNodes() {
      this.$confirm(
        `Are you sure you want to delete the node <strong>${this.id}</strong> ?`
      ).then((res) => {
        if (res) {
          this.removeNode({
            skillId: this.$route.params.skillId,
            idNode: this.id,
          }).then(() => {
            this.$emit("onUpdateDelete", this.node);
          });
        }
      });
    },
    enableNameEditMode(shouldEnable = false) {
      this.nameEditMode = shouldEnable;

      console.log("name : ", this.node.name);

      if (this.nameEditMode) {
        // this.$nextTick(() => {
        // this.$refs.nameEditInput.focus();
        // });
      } else {
        this.updateNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          data: { name: this.node.name },
        });
      }
    },
    createAnchorOnEvent(data) {
      this.createAnchor({
        skillId: this.$route.params.skillId,
        id: this.id,
        data,
      })
        .then((anchor) => {
          this.node.anchors.push(anchor);
        })
        .catch((err) => {
          console.log(err.response.data.message);

          this.$toasted.error(err.response.data.message);
        });
    },
    onDeletedAnchor(idAnchor) {
      this.$confirm(`Are you sure you want to delete the Anchor ?`).then(
        async (res) => {
          if (res) {
            this.removeAnchor({
              skillId: this.$route.params.skillId,
              idNode: this.id,
              idAnchor,
            }).then((anchor) => {
              for (var i = 0; i < this.node.anchors.length; i++) {
                if (this.node.anchors[i]._id === idAnchor) {
                  this.node.anchors.splice(i, 1);
                  break;
                }
              }
            });
          }
        }
      );
    },
    onAnchorChanged({ id, type, name, variable, value, available }) {
      this.updateAnchor({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        idAnchor: id,
        data: { variable, value, name, available },
      }).then((anchor) => {
        for (var i = 0; i < this.node.anchors.length; i++) {
          if (this.node.anchors[i]._id === id) {
            this.node.anchors[i].name = anchor.name;
            this.node.anchors[i].variable = anchor.variable;
            this.node.anchors[i].value = anchor.value;
            this.node.anchors[i].available = anchor.available;
            break;
          }
        }
      });
    },
    callAction(action) {
      const defaultAddNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
      };

      if (action === "cloneNode") {
        this.cloneNodes();
      }
      if (action === "deleteNode") {
        this.removeNodes();
      }
      if (action === "commentNode") {
        this.expandComment = true;
        this.editingComment = true;
      }
      if (action === "connectNode") {
        this.$emit("onConnectNode", this.node);
      }
      if (action === "duplicateSelection") {
        localStorage.setItem("duplcateSelectionBool", true);        
      }
    },
    shouldShowItem(item) {
      if (item.action === "duplicateSelection") {
        const selectedNodes = JSON.parse(localStorage.getItem("selectedNodes")) || [];

        return selectedNodes.length === 0;
      }
      // If showState is not defined or false, always show the item
      return false;
    },
    show(e) {
      e.preventDefault();
      console.log(e);
      if (this.showMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async addComment() {
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { comment: this.node.comment },
      });
      this.editingComment = false;
    },
    handleBookmark() {
      if (this.node.isSaved) {
        this.unsetFavourite();
      } else {
        this.setFavourite();
      }
    },
    connectionAnchor(event) {
      let eventData = {
        anchor: event.id,
        anchorOutState: event.anchorOutState,
        node: this.$refs.node.$el.id,
        nodeId: this.id,
      };
      this.$emit("onConnectionAnchor", eventData);
    },
    async markEndNode(event) {
      await this.updateNode({
        skillId: this.$route.params.skillId,
        idNode: this.id,
        data: { end: event },
      });
    },
    async MarkNonAvailableNode(event) {
      // await this.updateNode({
      //         skillId: this.$route.params.skillId,
      //         idNode: this.id,
      //         data: { available: event }
      // })
      console.log("this result received in noce : ", {
        available: event.available,
        anchors: event.anchorsList,
      });
    },
    handleHoverAnchor(event) {
      let nodesDom = document.getElementsByClassName("pertimm-node");
      if (event.active) {
        for (let node in nodesDom) {
          let foundNode = nodesDom[node].__vue__?.node;
          foundNode?.anchors.map((anchor) => {
            if (anchor._id === event.connection.targetId) {
              nodesDom[node].classList.add("selectedAnchor");
            }
          });
        }
      } else {
        for (let node in nodesDom) {
          let foundNode = nodesDom[node].__vue__?.node;
          foundNode?.anchors.map((anchor) => {
            if (anchor._id === event.connection.targetId) {
              nodesDom[node].classList.remove("selectedAnchor");
            }
          });
        }
      }
    },
    handleExpandComment() {
      this.expandComment = !this.expandComment;
      if (this.editingComment) this.expandComment = false;
    },
    EnableEditingComment() {
      this.editingComment = true;
      this.expandComment = false;
    },
    handleCommentToggle() {
      if (this.expandComment) this.expandComment = false;
    },
    openCommentMenu(event) {
      console.log("Clicked !");
      this.x = event.clientX;
      this.y = event.clientY;
      this.showCommentMenu = true;
    },
    async deleteComment() {
      console.log("deleting...!");
      (this.node.comment = ""),
        // this.addComment();
        await this.updateNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          data: { comment: "" },
        });
    },
    handleDrop(e) {
      console.log({
        source: e.drag.el._jsPlumbRelatedElement,
        target: this.$refs.anchorIn[0]?.$options?.propsData?.id,
        hoverPaintStyle: { strokeWidth: "10px" },
      });
      this.canvas.connect({
        source: e.drag.el._jsPlumbRelatedElement,
        target: this.$refs.anchorIn[0]?.$options?.propsData?.id,
        hoverPaintStyle: { strokeWidth: "10px" },
      });
    },

    startChat() {
      const patientId = this.patientId ? this.patientId : this.demoPatientId;
      const url = `/projects/${this.$route.params.id}/chat/${this.userId}/patient/${patientId}`;
      //Set the context
      this.$http
        .post(url, {
          metadata: null,
          text: "Chat start from node",
          startFromNode: this.node,
        })
        .then((data) => {
          // Store data in the locale storage
          localStorage.setItem("chatData", JSON.stringify(data.data));

          // Open the chat
          const newUrl = `/project/${this.$route.params.id}/chat`;
          const newWindow = window.open(newUrl, "_blank");
        })
        .catch((error) => {
          // Handle error
          console.error("An error occurred:", error.message);
        });
    },
    async handleDoubleClickOnAction(index, action) {
      if (action.actionType !== "vikyAction") {
        this.dialogEditAction = true;
        this.editingMessage = true;
        this.actionIndex = index;
      }
      else {
        const currentNode = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        const nodeAction = currentNode.actions[index];
        if (nodeAction.name.includes('long')) {
          currentNode.actions[index].name = "Waiting for a short response";
        }
        else {
          currentNode.actions[index].name = "Waiting for a long response";
        };
        let newAction = await this.updateAction({
          skillId: this.$route.params.skillId,
          idNode: this.id,
          action: nodeAction,
          actionId: currentNode.actions[index]._id,
        });

        let updatedNode = await this.getNode({
          skillId: this.$route.params.skillId,
          idNode: this.id,
        });
        this.node.actions = updatedNode.actions;

      }
    },
  },
  computed: {
    canvas: {
      get() {
        return this.$store.state.canvas.canvas;
      },
    },
    anchors: {
      get() {
        const inAnchors = [];
        const outAnchors = [];

        this.node.anchors.forEach((anchor) => {
          if (anchor.out) {
            outAnchors.push(anchor);
          } else {
            inAnchors.push(anchor);
          }
        });

        return { in: inAnchors, out: outAnchors };
      },
    },
    sortedOutAnchors() {
      return [...this.anchors.out].sort((a, b) => {
        if (a.name === "default") return 1;
        if (b.name === "default") return -1;
        return 0;
      });
    },
    commentTitle: {
      get() {
        if (this.node.comment) {
          if (this.node.comment.length > 25) {
            return this.node.comment.substr(0, 20) + "...";
          } else {
            return this.node.comment;
          }
        }
      },
    },
    shouldDisplayConnectionAction: {
      get() {
        if (this.excludedNode) {
          return this.id !== this.excludedNode;
        } else {
          return false;
        }
      },
    },
    getSkillName() {
      return function(id) {
        const skill = this.skills.find((skill) => skill._id === id);
        return skill ? skill.name : "";
      }.bind(this);
    },
  },
  watch: {
    // nodeMessages: {
    //   async handler(newValue, oldValue) {
    //     // console.log('watch nodeMessages : ', this.nodeMessages)
    //     if(newValue.length !== oldValue.length) {
    //       // Perform actions based on the change in length
    //       let action =this.node.actions.filter((action => {
    //         if(action.actionType === 'message' && action.args.includes(oldValue[0])) {
    //           return action
    //         } 
    //       }))
    //       action[0].args = newValue;
    //       let actionIndex = this.node.actions.indexOf(action);
    //       if(actionIndex) this.node.actions[actionIndex] = action;  
    //       let updatedAction = this.node.actions[actionIndex][0];
    //       await this.updateAction({
    //         skillId: this.$route.params.skillId,
    //         idNode: this.id,
    //         action: updatedAction,
    //         actionId: updatedAction._id,
    //       });
    //       const node = await this.getNode({
    //         skillId: this.$route.params.skillId,
    //         idNode: this.id,
    //       });
    //       this.node = node;
    //     }
    //   },
    //   deep: true // Set deep to true to watch changes inside the array
    // }
  },
  mounted() {
    const self = this;
    self
    .getNode({ skillId: self.$route.params.skillId, idNode: self.id })
    .then((data) => {
        self.node = data;
        let nodeMessageAction = data.actions.filter(action => {
          if(action.actionType === "message") {
            self.nodeMessages = action.args;
            return action;
          }
        })
        self.$nextTick(() => {
          self.$refs.node.$el.style.left = `${self.node.position.x}px`;
          self.$refs.node.$el.style.top = `${self.node.position.y}px`;

          self.canvas.draggable(self.$refs.node.$el, {
            stop: ({ finalPos }, ui) => {
              self.updateNode({
                skillId: self.$route.params.skillId,
                idNode: self.id,
                data: { position: { x: finalPos[0], y: finalPos[1] } },
              });

              for (let dbId in this.$parent.selectedElements) {
                const canvasId = this.$parent.selectedElements[dbId].canvasId;
                const currentNode = document.getElementById(canvasId);

                const currentPosition = {
                  x: currentNode.offsetLeft,
                  y: currentNode.offsetTop,
                };

                if (dbId !== self.id) {
                  self.updateNode({
                    skillId: self.$route.params.skillId,
                    idNode: dbId,
                    data: { position: currentPosition },
                  });
                }
              }
            },
          });
          if (self.node.isSaved) {
            let nodeRef = this.$refs;
            nodeRef.node.$el.style.backgroundColor = "lightsteelblue";
          }
          if (data.actions.length === 0) {
            this.showAddActionButton = true;
          } else {
            this.showAddActionButton = false;
          }
          const selectedNodes = localStorage.getItem("selectedNodes") || [];
          if (selectedNodes && selectedNodes.includes(this.id)) {
            this.$el.classList.add('selected');
          }
        });
      });
    // this.getIntents();

    // setTimeout(()=>{
    //   // this.$nextTick(()=>{
    //     if(this.$refs.anchorIn !== undefined) {
    //       let endpointAnchorId = this.$refs?.anchorIn[0]?.$options?.propsData?.id;
    //       this.canvas.makeTarget(
    //           this.$refs?.node?.$el,
    //           Object.assign({}, this.anchorDefaultOptions, {
    //             endpoint: 'Blank',
    //             isTarget: true,
    //             uniqueEndpoint: true,
    //             dropOptions: {
    //               hoverClass: 'drag-hover',
    //               drop: this.handleDrop
    //             },
    //             parameters: { _idTarget: endpointAnchorId, contextTarget: this.$refs.anchorIn[0], id: endpointAnchorId },
    //           })
    //         );
    //     }
    //   // })
    // }, 100)
    setTimeout(() => {
      if (this.$refs.anchorIn !== undefined) {
        let endpointAnchorId = this.$refs?.anchorIn[0]?.$options?.propsData?.id;
        this.canvas.makeTarget(
          this.$refs?.node?.$el,
          Object.assign({}, this.anchorDefaultOptions, {
            endpoint: "Blank",
            isTarget: true,
            uniqueEndpoint: true,
            dropOptions: {
              hoverClass: "drag-hover",
              drop: this.handleDrop.bind(this),
            },
            parameters: {
              _idTarget: endpointAnchorId,
              contextTarget: this.$refs.anchorIn[0],
              id: endpointAnchorId,
            },
          })
        );
      }
    }, 1000);
  },
  async beforeMount() {
    this.getSkills();
    this.actions = await this.getActions({ filter: this.filterAction });
    await this.loadAnchorTypes(this.$store);
  },
};
</script>

<style scoped>
.pertimm-node {
  position: absolute;
  z-index: 999;
}
.v-card--link:before {
  opacity: 0 !important;
}
.my-node {
  position: relative;
}
.node-name-input >>> input {
  text-align: center;
}

.node-name-label {
  /* min-width: 200px; */
  min-height: 39px;
  position: absolute;
  top: -30px;
  left: 0px;
  font-size: medium;
  font-weight: bold;
}
.height-200 {
  height: 200px;
}
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}
/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
/* Node selection */
.selected {
  box-shadow: 0 0 10px 2px #00ced1; /* outer cyan */
}

.selectedAnchor {
 box-shadow: 0 0 10px 2px #f51010; /* outer cyan */ 
}

/* .wrap-action {
  margin: 2px 0px 2px 0px;
  border-radius: 5px !important;
  padding: 5px;
}

.wrap-action span {
  font-size: 14px;
}

.wrap-action-message{
  background-color: #E9E9E9;
}

.wrap-action-customAction {
  background-color: #CEBCFF;
}

.wrap-action-vikyAction {
  margin: 0px 0px 0px 0px;
  padding: 2px;
  
}
.wrap-action-vikyAction span {
  font-size: 11px;
  font-style: italic;
  text-align: center;
}

.actions-bloc {
  margin: 0px;
  padding: 10px;
} */

.jsPlumb-canvas-container22 {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  outline: none;
  overflow: hidden;
  max-height: 100vh;
  max-width: 100vw;
}

.v-alert {
  margin-bottom: 0px !important;
  padding: 16px 16px 0px 16px !important;
}

.expandDuv {
  margin-bottom: -25px !important;
  margin-left: 80px;
  position: absolute;
  width: 95%;
  top: 255px;
}

.paragraphsContainer {
  margin-left: 15px;
}

.paragraph {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  align-items: center;
}

.white-text {
  color: white !important;
  font-weight: bold;
}

#input-366 {
  margin-top: Opx;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot {
  margin-top: 0px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot::before {
  border: none !important;
}

::v-deep .commentTextarea > .v-input__control > .v-input__slot::after {
  border-color: #69cb85 !important;
}

::v-deep
  .commentTextarea
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot {
  padding: 5px;
}
.custom-textarea {
  border-radius: 18px; /* Border radius if needed */
}

::v-deep .v-text-field__details {
  display: none;
}
</style>
